{
  "default": {
    "home_button": "Go back to Dashboard",
    "subtitle": "Sorry, we can't find the page you're looking for. Try to hit the refresh button or get back to the Dashboard.",
    "title": "Page not found"
  },
  "no_sites": {
    "title": "No Sites Found"
  },
  "user_disabled": {
    "subtitle": "Functionality is limited."
  }
}
